var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrolleybus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,4h-0.52l1.2-3h-2.16l-1.2,3H9.68l-1.2-3H6.32l1.2,3H7C4.79,4,3,5.79,3,8v13.26C3,21.67,3.34,22,3.75,22H6v-2h12v2h2.25 c0.41,0,0.75-0.33,0.75-0.74V8C21,5.79,19.21,4,17,4z M8,16c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S8.55,16,8,16z M16,16 c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S16.55,16,16,16z M19,11H5V8c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2V11z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolleybus);
export default __webpack_public_path__ + "static/media/trolleybus.ba6a3de2fad8d4b694111545b43b6c99.svg";
export { ForwardRef as ReactComponent };